import { GraphQLError } from 'graphql/error';
import { getConfig } from '../../main-app/utils/config';

const { gqlApiEndpoint } = getConfig();

/**
 * Fetcher function for react-query, referenced in config for codegen.
 */
export function useInvoiceAppFetcher<TData, TVariables>(
  query: string,
  options?: RequestInit['headers'],
): (variables?: TVariables) => Promise<TData> {
  return async (variables?: TVariables): Promise<TData> => {
    const res = await fetch(gqlApiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        ...options,
      },
      mode: 'cors',
      body: JSON.stringify({ query, variables }),
    }).catch((e) => {
      throw new GraphQLError(e);
    });

    const json = await res.json();
    const gqlError = json.errors?.[0];
    if (gqlError) {
      throw new GraphQLError(gqlError.message, gqlError.extensions?.code, gqlError.extensions?.error);
    }

    return json.data;
  };
}
